// extracted by mini-css-extract-plugin
export default {"secondaryHeaderRow__name":"DocumentNameHandler_secondaryHeaderRow__name__Sn94p","secondaryHeaderRow__documentName":"DocumentNameHandler_secondaryHeaderRow__documentName__++2rW"};